import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CategoryMenuBar.css';

const categories = [
  { label: 'Chickens', image: '/Categorys/rooster.png', link: '/category/chickens' },
  { label: 'Pets', image: '/Categorys/pet.png', link: '/category/pets' },
  { label: 'Cattle', image: '/Categorys/cow.png', link: '/category/cattle' },
  { label: 'Sheep/Goat', image: '/Categorys/goat.png', link: '/category/sheep-goat' },
];

const CategoryMenuBar = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (link) => {
    navigate(link);
  };

  return (
    <nav className="category-menu-bar">
      {categories.map((cat, idx) => (
        <React.Fragment key={cat.label}>
          <div
            className="category-menu-item"
            onClick={() => handleCategoryClick(cat.link)}
            style={{ cursor: 'pointer' }}
          >
            <img 
              src={cat.image} 
              alt={cat.label} 
              className="category-image"
            />
            <span className="category-label">{cat.label}</span>
          </div>
          {idx < categories.length - 1 && <span className="category-divider" aria-hidden="true"></span>}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default CategoryMenuBar; 